'use client';

import React from 'react';
import { cn } from '@/lib/cn';
import { Divider, StarRating } from '@/components/ui';

interface RatingContainerProps {
  averageRating: number;
  reviewCount: number;
}

/**
 * Rating Container - matches Figma design 5979-185935
 * Displays rating value, stars, vertical divider, and review count
 */
export function RatingContainer({ averageRating, reviewCount }: RatingContainerProps) {
  return (
    <div className={cn('flex items-center justify-center md:justify-start gap-4 px-2 py-3')}>
      {/* Rating and Stars */}
      <div className={cn('flex items-center gap-3')}>
        <span className={cn('text-heading-4 text-primary whitespace-nowrap')}>
          {averageRating?.toFixed(1) || '0.0'}
        </span>
        <StarRating
          rating={averageRating || 0}
          starSize={16}
          starSpace={4}
          fillClassName="icon-rating"
          emptyClassName="icon-tertiary"
        />
      </div>
      {/* Vertical Divider - matches Figma (20px height) */}
      <Divider variant="tertiary" orientation="vertical" className="h-5" />
      <p className={cn('text-body-2 text-secondary whitespace-nowrap')}>
        {reviewCount && reviewCount > 0 ? `${reviewCount} reviews` : 'No reviews yet'}
      </p>
    </div>
  );
}
